module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "dropcap1"
  }, [_c('em', [_vm._v("C")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 3")])]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('em', [_vm._v("T")])]), _vm._v("ea, my lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth closed her book and placed it on the overstuffed arm of her chair, the delicate wrinkles about her green eyes crinkling with her smile. “Briggs, you read my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As I do every day at four.” Smiling gently, he held the silver tray a bit lower, noting how my lady’s delicate, blue-veined hands shook slightly when she took her cup.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Her hands seemed to shake more each day, a fact that weighed upon his heart, though he was careful not to acknowledge it by so much as a blink. He had been with Lady MacToth since he was a lad of sixteen and she a newly married woman of twenty. ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("She was quite different then, a blazing actress feted by the world until she’d stunned society by marrying wealthy Lord MacToth, a man several decades older and far above her in social class. To the bride and groom it was the happiest day of their lives, but to some members of the ton, the marriage was a social disaster. Lord MacToth had married beneath his station and they would not soon forget it.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“More sugar, my lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please!” Lady MacToth smiled like a child as he dropped two lumps of sugar into the steaming tea. His mistress took such joy in the simple things in life. It was unfortunate Lord MacToth hadn’t been able to do the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had been determined to prove to the world that his choice of a wife was no mistake, and he did so in grand fashion. He bought her the largest town house in Mayfair and filled it with enough fine furnishings and priceless art to earn it the nickname the Castle; dressed her as finely as any princess and draped her in enough jewels to win over a sultana. But try as he might, he could not buy society’s cold approval.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Society did not forget, and it "), _c('em', [_vm._v("never")]), _vm._v(" forgave.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Briggs sighed to think of those early days. Lady MacToth had blithely ignored the slights and cuts, for her life had been filled with so many already that a few more were nothing to her. But Lord MacToth ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("had been horribly hurt when people he’d considered his friends had turned their backs on his bride.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Briggs could have told them how Lord and Lady MacToth had fallen wildly, deeply, and passionately in love at very first sight, and it was that love that reconciled Lord MacToth to his new life. He avoided the society that had rejected his beloved and traveled to the Continent, where they were able to enjoy each other almost exclusively. Three years after the wedding came the birth of a daughter, who joined the couple in their solitary life of travel and luxurious pleasures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those were the Idyllic Years. Unfortunately, Lord MacToth’s absence from English soil, where most of his investments were held, combined with a significant increase in spending as he attempted to shut out the ugliness of the world by dazzling his lovely young wife and new child with the finest of everything, caused a steady and unfortunate reversal in his fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Worse, Lord MacToth turned a blind eye to every warning sign of his fortune’s impending doom, including increasingly strident letters from his solicitors to return home to repair the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Years passed, his fortune dwindled, and Lord MacToth found it harder and harder to shield his wife and daughter from the truth.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Briggs believed it was that strain which ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("ultimately led to my lord’s blindingly sudden death. One day, his lordship complained of being tired and went to lie down for a nap. He never rose again.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth had been devastated, but she was made of sterner material than her husband. Upon being informed by his late lordship’s solicitor of the estate’s distressed situation, Lady MacToth faced reality without a flinch. She took her daughter out of the expensive boarding school in France and brought her home to England, placed the four largest of their five houses up for sale, dismissed unnecessary staff, and ruthlessly sold almost all of the famed MacToth treasures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth oversaw each sale herself, and through her wily negotiations received top prices, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when all was said and done and the mound of bills paid, Lady MacToth had only enough to continue to live very quietly and modestly in the remaining house on the edge of Mayfair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surrounded on all sides by up-and-coming tradesmen and their families, its location would not be satisfactory to a high stickler. But Lady MacToth had never wished to join society and she thought the small house lovely. She with her daughter, Lucinda lived there very simply until the child grew up, married, and moved into her own house.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("As he lifted a small plate, Briggs repressed a sigh ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("at the thought of Miss Lucinda. “A tea cake, my lady?”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth chuckled, her self-conscious gurgle of laughter making her sound like a young girl. “Did you hear my stomach rumble?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, indeed.” Briggs picked up the tongs and placed a small cake upon a delicate Wedgewood plate and set it by her ladyship. “It’s just that I know you so well, my lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That you do.” Lady MacToth took a nibble of the moist cake. “Briggs, it’s lemon. My favorite! I don’t know what I’d do without you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither did Briggs—for with the exception of one of her granddaughters who visited often, Lady MacToth was quite alone in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A deep gong sounded and my lady looked up. “Are we expecting a visitor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, my lady.” Briggs stepped to the nearby window, lifted the edge of the curtain, and then smiled. “It’s Miss Marcail.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How lovely!” Lady MacToth took a sip of tea and carefully replaced her teacup, the bottom chattering against the saucer. “I wonder why she’s come unannounced? She usually sends a note before—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The door opened and a footman stood to one side as her ladyship’s granddaughter entered the sitting room. Tall and slender, her delicate hourglass figure encased in a dashing pelisse of sea green set with navy blue ruches of ribbons, Miss Marcail Beauchamp was ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("the picture of fashion. She tossed aside her veil, removed her fetching bonnet, and shook out the black curls that fell artfully about her face.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no denying her breathtaking beauty as she breezed across the room, a younger version of her once beautiful grandmother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Briggs bowed. “Miss Marcail, what a pleasure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She flashed a friendly smile. “Good afternoon, Briggs. How is your wife? I hope she’s feeling better than when I was here last time. She had the toothache, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The Morning Post")]), _vm._v(" had once reported that a Russian prince had paid ten thousand pounds for the pleasure of having Miss Beauchamp sing a song at his birthday fete. Hearing that voice, Briggs could only imagine that the astronomical sum had been worth every penny. “My wife is feeling much improved, miss. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth held out her hands to her granddaughter. “You are just in time for tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds lovely.” Marcail gave her grandmother a swift hug. “Good afternoon, Grandmamma. I hope you’re well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lady MacToth patted the space beside her on the settee. “I’m fine. Wondering, perhaps, why you’ve come in such haste that you didn’t send a note as you usually do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail cast a glance at Briggs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The elderly butler immediately bowed and walked toward the door. “I shall bring tea and more cakes.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as the door closed behind him, Marcail turned to her grandmother. “Yes, I’m fine. Yes, I’m eating well. And no, I’m not in love. Now that that’s out of the way, we can talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s lips quirked, her eyes twinkling. “Am I so predictable that you can answer all of my questions before I even speak them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but only in the dearest way possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail was close to her grandmamma, which was a good thing for them both. Except for each other they were quite alone in the world, a state which was bearable when one was twenty-seven, but not as much so—Marcail suspected—at a more advanced age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was Mother’s fault, for allowing Father’s silly pretensions to define who she could and could not see. Marcail’s father was Sir Mangus Ferguson, an impoverished Irish peer overly taken with his own lineage, and who did not approve of Grandmamma—though he was more than willing to accept her money until his profligate spending had forced her to cut him off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father had never forgiven her and he had forbidden his wife and five daughters to ever speak to Grandmamma again. It was a good thing Marcail never listened to Father. Even at fifteen, she’d already realized he was a braggart and a fool.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("A soft knock announced Briggs, who appeared with a tray. Within seconds, she had a cup of hot tea and a plate with a tea cake, as a snowy white linen napkin settled across her lap. “Thank you, Briggs.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“My pleasure, miss.” He turned to Grandmamma and asked in a gentle tone, “Would you like more tea before I retire, my lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no. I’m fine. Thank you, Briggs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He bowed and quietly left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail waited for the door to close. “He is a gem. My butler is not nearly so circumspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know what I’d do without him,” Grandmamma said honestly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think you need to worry. Not only is he very fond of you, but you are a generous mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It pays to take care of the ones who take care of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a good standard to live by.” Marcail tried to hold on to her belief in the inherent kindness of mankind, which she’d learned from Grandmamma long ago, but the events of the last few weeks had stretched that belief to breaking. Her heart sank as she thought of the note in her reticule. She wasn’t certain how, but she had to—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Marcail, dear, you’re staring at the teapot as if you think it might explode.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked up and forced a smile. “I’m sorry. I’m just a bit distracted.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("With a soft, “Oh no!” Grandmamma set down her tea. “You’ve heard from that horrible blackmailer again.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail grimaced. “I am quite the actress; I can’t even fool my own grandmother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did the note arrive this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I found it under my plate at breakfast this morning.” Which had been a chilling discovery. It was one thing to find the notes inside her coach or tucked into some flowers in her dressing room, and quite another to find one placed in her own home. Marcail had never felt so unsafe before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I dislike that,” Grandmamma said in her direct manner. “Did the servants see anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but they aren’t really my servants, they’re Colchester’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma shook her head. “I’ve been telling you these past two years that you should get your own house. It’s the least that a—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grandmamma!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s parchment skin flushed, but she said in a stubborn tone, “The earl is using you to cover his own proclivities.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I’m using him to keep away the unwanted attentions that were making my life unbearable. We both benefit, and he has been most kind. I owe him more than I can ever repay.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“I know, I know. He saved you from the regent ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("when that arse was attempting to force himself upon you, hoping to press you into becoming his mistress. I’ll forever be grateful to Colchester for his deft handling of that situation, but that doesn’t mean you are indebted to him forever. You’ve served a purpose in his life, as well.” Grandmamma raised an eyebrow. “I assume Colchester’s tastes are the same as ever?”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you are asking if he’s still wildly in love with George Aniston, then the answer is yes. They have been together for almost a year now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a long time for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it is. While Colchester’s ‘tastes’ are his own business, I don’t care for Aniston. He is forever asking for funds and throwing tantrums over trivial things. I wish Colchester would be rid of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He doesn’t sound like a pleasant man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not when he’s in a bad mood. However, when he’s in a good mood he is very charming, and Colchester is mad about him. I don’t think the relationship is good for Colchester with so many dramatic scenes—” Marcail shrugged helplessly. “I’ve told him what I think; that’s all I can do. He just shrugs and says that sometimes life doesn’t allow you to pick who you fall in love with, that it just happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s right about that; sometimes fate shoves you down a path you wouldn’t normally take.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Marcail silently agreed. She loved Colchester ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("dearly as the brother she’d never had. To the ton, he was a sought-after bachelor, eluding matchmaking mamas and their daughters with a skill that had won him the admiration of his peers. No one had ever guessed his secret, and he’d lived a shadow life for so long that he wore the second skin as comfortably as the first.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She would be forever grateful for his assistance during those early difficult days. The near situation with the prince had terrified her, a brutal reminder of her vulnerability. She was an actress with no social standing to protect her, no family to ward off those with impure intentions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Worse, at that time, she’d recently met—and straightaway fallen deeply in love with—William Hurst. After six months of a passionate whirlwind courtship, he’d been called back to sea for a three-week run to Dover. Even now, years later, her heart stuttered to a stop when she imagined how things might have turned out if hot, fiery William had heard about the prince’s attentions. He lacked Colchester’s understanding of the nuances of society. William’s reaction would doubtless have resulted in a physical confrontation that would have left the prince bloodied and furious, which would have ended both William’s career and her own. Thus her plan to save her sisters would have been ruined, and that fact had forced her to face the ugly hard cold ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("truth. As an actress she was a target for such improprieties, and that left no possibility of a relationship with William. She had to give him up, or risk causing both their ruins.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So it had seemed serendipitous when handsome, dashing Colchester had offered his protection in exchange for one simple thing: to assist him in keeping his secret from the eyes and ears of the ton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though it was the only answer to her dilemma, Marcail had wrestled with it, desperate for some way to keep her relationship with William intact. But there was none. Her heart breaking, she wrote William that she’d been mistaken in her love for him and that she’d found another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d hoped that the cold tone of the letter would prevent him from ever wanting to see her again, but immediately after he’d landed and received her letter, he’d stormed into her dressing room at the theater, his beloved face set with anger and hurt. Oh, the things he’d said—She winced. The things "), _c('em', [_vm._v("she’d")]), _vm._v(" said, too. It had been a horrible, painful time that even now made her eyes burn with tears.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("But that was the cost of the path she’d chosen. She resolutely pushed away the old memory, wishing her thoughts were as easy to control when she was asleep. In her dreams, she and William were still together. She’d dreamed of him every night since last ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("week when she’d left him on the floor of his cabin, only in her dreams he wasn’t angry. In her dreams he was tied to his bed, unable to move, naked as the day he was born as she caressed his—")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Marcail, you’re flushed. Are you catching the ague?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail placed a hand to her heated cheek. “No. I was just thinking about the—the blackmailer, and it made me angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It makes me angry, too. I wish you could ask Colchester for his help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail shook her head. “The fewer people who know the truth, the less likely it will be found out. As much as I love Colchester, he’s a horrid gossip. He’ll keep his own secrets to the grave, but cannot hold onto another’s for longer than it takes to repeat it.” She took Grandmamma’s hand between her own. “I’ve worked so hard to get where I am, and have sacrificed so much. I can’t stop now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s face softened. “Your sisters owe you a great deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They would do the same for me. "), _c('em', [_vm._v("Someone")]), _vm._v(" had to take control of our financial situation. If I’d left Father to run things, we’d all be in a paupers’ prison by now, the house lost to creditors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is a selfish man. I don’t know why Lucinda wished to wed him. She was raised to be more forward thinking than that.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("“I think he flattered her that she was better than everyone else.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Better than "), _c('em', [_vm._v("me")]), _vm._v(",” Grandmamma said, her eyes flashing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mother is wrong,” Marcail said soothingly. “She is stubborn and won’t admit her mistake, though I think she knows it. Father isn’t easy to live with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s shoulders slumped. “I wish your mother would just leave him, but I fear that will never happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t look so glum. At least the debts have been paid and there’s enough to fund a season for Elizabeth. And if all works out the way I’ve planned, by the time she’s had a season or two I should have enough saved for Margot. And then Jane and—” Marcail sighed. “But none of that will happen if the ton discovers that they are related to a common actress.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s face fell. “I suppose I shan’t see them when they’re in town, either, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t even think such a thing! They can claim the connection to you; our cases are quite different. Not only did you marry into the peerage, but it has been so long since you were on the stage that I doubt anyone would remember it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would take only one person, my dear. People are not as forgiving as you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then that’s their loss, for a more gracious and wonderful woman doesn’t exist.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“La, but you are a fire-breather, aren’t you? Unfortunately, that changes nothing. It would be better if I did not see your sisters.”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“So long as no one guesses "), _c('em', [_vm._v("my")]), _vm._v(" connection to you, we will be fine. I’ve been careful when I come to visit; I always wear my veil and I take a hackney coach rather than use my own, which might be recognized.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re always protecting other people, my dear. But what about "), _c('em', [_vm._v("you")]), _vm._v(", Marcail? What about "), _c('em', [_vm._v("your")]), _vm._v(" season?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m seven and twenty now, the time for my season has long passed.” Marcail chuckled at her grandmother’s expression. “Stop that! It’s not as if I’m slaving in some coal mine. I have a wonderful career, I make an excellent wage, I’m able to provide for my family, and I have you to share dinner with whenever I wish. What more could I ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma frowned. “You may trick some people into believing that silliness, but not me. I know of the slights and the illicit proposals and the lack of regard for your art.” She leaned forward. “I also know the personal price this charade has cost you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail wished she hadn’t confided about William all those years ago, but there was no undoing it now. She’d been sick with the loss, which had hurt far worse than she’d expected. For a few weeks, she hadn’t been able to leave her bed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Grandmamma had sent Briggs to her home every day with notes and tureens of hot soup. Eventually, Grandmamma herself had threatened to come visit. The thought of her frail grandmother braving the rough streets and cold weather had forced Marcail to rise. Though her spirits remained low for months, she never returned to the sickbed.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail waved a hand as if to banish that time. “I don’t think of it very often.” "), _c('em', [_vm._v("Until last week")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I do. You have enough on your shoulders. My child, we "), _c('em', [_vm._v("must")]), _vm._v(" stop this blackmailer. You can’t keep giving him sums and sums of money as you’ve been doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would do something about it if I only knew who he was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose this messenger, the red-haired woman, won’t give you a clue?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Marcail shook her head. “I get the distinct impression that Miss Challoner is afraid of the blackmailer. I’ve seen it in her eyes.” And Marcail didn’t get the impression that many things frightened Miss Challoner. The blackmailer’s messenger was an interesting woman, quite tall and amazingly beautiful, with red hair and green eyes and a confident bearing that set her apart. There were times when Marcail got the distinct impression that Miss Challoner’s hatred for the blackmailer quite equaled her own, but the woman refused to engage in conversation ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("beyond the necessary, merely accepting with a bland expression whatever bundle Marcail handed over for delivery. "), _c('em', [_vm._v("I wonder what the blackmailer holds over Miss Challoner’s head? It must be something quite weighty. The next time I’m alone with her, I shall ask. It can’t hurt matters")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do hope you’re being careful. I worry about your having commerce with these people. I also hate that you have to carry such large amounts of money to such horrid locations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t have to go to a horrid part of town this time. Of course, he didn’t ask for money, either.” A flicker of regret flared and she resolutely tamped it down. It wasn’t as if William had harbored tender thoughts of her before she’d stolen the artifact. If anything, she’d confirmed his already low opinion of her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did the blackmailer want, if not money?” Grandmamma asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wanted me to fetch an ancient artifact.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fetch?” Grandmamma’s eyes sharpened. “What do you mean by that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was told I must obtain an Egyptian artifact and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma grasped Marcail’s hand. “Please tell me that you haven’t done something you’ll be sorry for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course I haven’t.” Which was a complete and utter lie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s thin brows rose.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Marcail sighed. “The artifact didn’t belong to the person who held it, so it wasn’t precisely stealing. I hoped the artifact might be a clue to my blackmailer’s identity so I took it to someone who works with the British Museum. They examined it and said that, while ancient, it’s not that rare.”")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps the materials make it valuable?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. It’s made mainly of onyx, with very little gold, so … I just don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stranger and stranger.” Grandmamma shook her head and poured more tea into both cups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail noted how badly the older woman’s hands now shook. "), _c('em', [_vm._v("She’s getting so fragile. I shouldn’t be bothering her with my problems. I should—")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you should bring your problems to me.” Grandmamma sent Marcail a hard look before returning the teapot to the tray. “We are family, we two. Closer than most mothers and daughters.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail smiled. “You read my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hardly. Every time I wrest a problem from you, you tell me that it’s really none of my concern and not to bother myself with it.” Grandmamma’s green eyes were grave. “We are strong, and we will overcome all adversity—including Miss Challoner and the blackmailer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail fidgeted with the edge of her cuff. “There is another thing about this situation that made it worse.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“What could possibly make it worse? I can’t imagine—” Grandmamma’s gaze narrowed. “"), _c('em', [_vm._v("Whom")]), _vm._v(" did they ask you to steal this artifact from?”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail’s cheeks heated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Allow me to guess. Captain Hurst, perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then that’s why you’re so upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I’m upset because I’m being blackmailed. It has nothing to do with William Hurst.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma took a sip of her tea, her shrewd gaze never wavering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honestly, it’s been years since I saw him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma listened politely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In fact, I wasn’t even certain I’d remember what he looked like.” He’d looked exactly as he had the last time she’d seen him—tall and powerful, his black hair framing his incredible dark blue eyes, and—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma cleared her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail threw up her hands. “Oh, very well! He looked exactly the same, only older.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma nodded. “I’m not surprised it was difficult to see him. You were most taken with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than taken. She’d been wildly, passionately in love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And when she’d seen him again, she’d felt like that mad, impulsive innocent all over again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("If she closed her eyes now, she could see his blue ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("eyes and dark hair, the cleft of his chin and the sparkle of his grin, and how his large hands had made her feel so—")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your blackmailer must know of your past relationship with Hurst.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail slanted a look at her grandmother. “How could he? It happened so long ago, and I was barely known then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t believe in coincidences.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, if the blackmailer thought that our past history worked in my favor, then he was sadly mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a pity you can’t go to Bow Street. But I suppose you’re right; the fewer involved, the better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail placed her hand on Grandmamma’s knee. “We’re already set on this course. There’s no sense regretting it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We all owe you so much, dear. Though Briggs never mentions it, I know that the coal bins are always full and we have much better cuts of meat since you arrived in London.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not me, it’s Briggs. He’s an excellent bargainer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve learned much from him over the years. I wish MacToth had done the same.” Grandmamma looked at the portrait of a handsome man over the fireplace and her expression grew dreamy. “I wish you could have met him, Marcail. He would have liked you. He enjoyed women with spirit.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“I’m sure he did. He married you, didn’t he?” Marcail chuckled. “One day, you and I will find a lovely house in the country where no one ever needs to know who or what we are.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandmamma’s shrewd green gaze locked on Marcail. “You’d give up the stage? Just like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail hesitated. “Perhaps not completely. It’s who I am, and I enjoy it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are better than I ever was. I saw your Lady MacBeth last Wednesday, and you were magnificent. Better even than Mrs. Siddons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail threw up a hand. “Grandmamma, "), _c('em', [_vm._v("no one")]), _vm._v(" will ever be better than Mrs. Siddons. She may have retired from the stage a decade ago, but her presence is still keenly felt by all actresses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sarah Siddons was a very good actress; I should know, for I worked with her myself. But last week, you outshone even her. While I wish you hadn’t forsaken your birthright, I could not be prouder of your talent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you. That means more to me than I can say.” Marcail glanced at the clock over the mantel. “I wish I could stay longer, but I must go. The note I received this morning said that I’m to deliver the artifact to an inn in Southend. I have only three days before I’m due back onstage, so I must leave today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Southend? I don’t like this at all. Please be careful.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("“Don’t worry, Grandmamma. I’ll be fine. I always am.” She stood and dropped a kiss on the snowy white forehead. “As soon as I return, we’ll have dinner.”")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be waiting, so please send me word that all is well.” Grandmamma waved her hand. “Off with you. Get this task done and over with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail gave her grandmother one last hug, then waited in the front hallway while Briggs called a hackney. When one pulled up to the stoop, she tucked her veil firmly in place and entered the carriage quickly, allowing Briggs to give her destination—a street corner several blocks from her home—to the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a wave to Briggs, Marcail settled back against the worn squabs and planned her coming journey. The coach rattled down the street, then rounded a corner and headed toward Hyde Park.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not far away, a man dressed in the drab browns and grays of the working class watched, the thronging mill of people and carts swirling past him and his horse as if they were a rock in the middle of a swift stream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Expressionless, he watched the hackney rumble past. Just before it turned at the end of the street, he murmured a word to his horse, jumped into the saddle and followed the hackney as it disappeared around the corner.")])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('em', [_vm._v("A letter from Michael Hurst to his brother William, from a ship rounding Gibraltar")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It pains me to admit it, but I’m a wretched sea traveler. I haven’t left my bunk since we left port in Old Alexandria. If it weren’t for Miss Smythe-Haughton and her infernal draughts, I would now be asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But since I am able to sit up and write, I find myself wondering why you are able to go to sea for such lengths of time while my stomach protests if I merely set foot upon a ship. It makes me wonder which tendencies are decided by birth, and which by desire.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f37e6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 93
// module chunks = 0